import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { AbstractAuthService } from './services/auth/auth.abstract.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  private _canActicate = false;
  constructor(private authService: AbstractAuthService, private router: Router, private location: Location, private route: ActivatedRoute) {

    this.authService.authenticateUser().subscribe((val) => {
      if (val) {
        if (window.location.pathname === '/') {
          this.routeToPage('/dashboard');
        }
      }
      this._canActicate = val;
      this.authService.isBpLoggedIn$.next(val);
    });
    this.applyRoutingRules();
  }

  public canActivate(): boolean {
    return this._canActicate;
  }

  private applyRoutingRules(): void {
    this.router.events.subscribe((val: NavigationStart) => {
      if (this._canActicate) {
        if (val.url === '/' || (val.url === '/search_forms' && !this.authService.shouldHaveSearchAccess)) {
          this.routeToPage('/dashboard');
        }
      }
    });

    this.route.queryParams.subscribe((params) => {
      const { appid } = params;
      if (appid) {
        sessionStorage.setItem('app-uid-token', appid);
      }
    });
  }

  private routeToPage(name:string): void {
    this.location.replaceState(name);
    window.history.pushState(name, name);
    this.router.navigate([name]);
  }
}
